export default "<button>TEST 1</button>\n<button>TEST 2</button>\n<button>TEST 3</button>\n\n<pre>{{ data | json }}</pre>\n"